import { inject } from '@angular/core';
import { AuthService, LayoutService } from '@services';
import { RemoteConfigService } from 'moddy/common';

export async function appInitializer(): Promise<unknown> {
    const authService = inject(AuthService); // Create instance for the @AuthorizedUser decorator
    const remoteConfigService = inject(RemoteConfigService);

    initSakai();

    return Promise.all([authService.init(), remoteConfigService.update()]);
}

function initSakai(): void {
    const layoutService = inject(LayoutService);
    const layoutPreset = layoutService.layoutConfig().preset;

    setTimeout(() => {
        layoutService.layoutConfig.update((state) => ({ ...state, preset: layoutPreset }));
    });
}
